import { render, staticRenderFns } from "./Pf-Terminal-Statistics-page.vue?vue&type=template&id=456e3e9a"
import script from "./Pf-Terminal-Statistics-page.vue?vue&type=script&lang=js"
export * from "./Pf-Terminal-Statistics-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports